import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import * as storage from 'redux-storage';
import filter from 'redux-storage-decorator-filter';
import createEngine from 'redux-storage-engine-localstorage';
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { includes } from 'lodash';
import {
  CALL_API,
  hasValidSessionSelector,
  sessionTokenSelector,
  SET_SESSION,
} from '../lib/dataLayer';
import apiMiddleware from './middleware/apiMiddleware';
import gatewayMiddleware from './middleware/gatewayMiddleware';
import reducers from './reducer';
import { clearStore } from './actions';

const history = createHistory();

const rootReducer = storage.reducer(reducers);

const storageEngine = filter(
  createEngine('palliative-care'),
  [],
  [['ui', 'error'], ['ui', 'loading']],
);

const storageMiddleware = storage.createMiddleware(storageEngine);
const storageLoader = storage.createLoader(storageEngine);

function validator(state, action) {
  const validTypes = [storage.LOAD, SET_SESSION];
  return hasValidSessionSelector(state) || includes(validTypes, action.type);
}

const apiConfig = {
  apiActionType: CALL_API,
  rootUrl: `${process.env.REACT_APP_API_HOST}/api`,
  tokenSelector: sessionTokenSelector,
  responseStatusActionCreators: {
    401: response => dispatch => {
      dispatch(clearStore());
      return response.json().then(body => {
        return Promise.reject({
          body,
          status: response.status,
          statusText: response.statusText,
        });
      });
    },
    204: () => () => ({}),
  },
};

const store = createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(
      apiMiddleware(apiConfig), // Order matters
      thunk,
      storageMiddleware,
      routerMiddleware(history),
      gatewayMiddleware(validator, clearStore),
    ),
  ),
);

storageLoader(store);

export default store;
export { history };
export * from './actions';



// WEBPACK FOOTER //
// ./src/store/index.js